export const EVeriffWatchlistStatus = {
  no_match: "no_match",
  possible_match: "possible_match",
} as const;
export type EVeriffWatchlistStatus =
  (typeof EVeriffWatchlistStatus)[keyof typeof EVeriffWatchlistStatus];
